const formatQuestionId = (mainId, subLetter = null, subSubLetter = null) => {
    // Return empty string to stop rendering question numbers
    return '';
};

export default formatQuestionId;